import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9t2gzzvf8: FaireProductEntity = {
  token: "p_j9t2gzzvf8",
  type: "product",
  name: 'Wht/Brn Ball Mug-3.5"H(16oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/94ae9574dea3b6bbe08aee4bade304434a70eb3d9d925a8ce34d7c6262922316.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8ebf02d183014aea6ea87c2f685be59e6e37d6ce450f2ae44803fb7b1f88030.jpeg",
    "https://cdn.faire.com/fastly/fe9a05ff226687baa807d2a03f39972a73acd786171197eaa1b3b29a6ee0410a.jpeg",
    "https://cdn.faire.com/fastly/b833f595d58c06d20c4b9aac27ced9fb36585974383179dc2cde9407f074cea2.jpeg",
    "https://cdn.faire.com/fastly/7b0a6a08b1c45b8cbb7acf3a1344ad792201d504c27e44585dec26def3acc3ee.jpeg",
    "https://cdn.faire.com/fastly/4801712564705ee3189753b72dac738f32d6626ac416a3f69a65dac7fb4b2923.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Add a charming rustic touch to your morning routine with this Ball Mug in White and Brown. Crafted out of stoneware with an elegant two-tone striped design, this mug is perfect for enjoying a hot cup of tea or coffee from the kitchen to the cottage. Also available in other colours.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:16.895Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
